import type { UncoveredEntity } from '@mollusk/shared';

const compact = new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 1 });

/**
 * One-line account of what a state's permit coverage is missing: the largest
 * uncovered entities by name + population, with the long tail rolled into an
 * explicit "+N more" so nothing is silently dropped.
 */
export function summarizeUncovered(uncovered: readonly UncoveredEntity[], topN = 4): string {
  if (uncovered.length === 0) return 'Nothing left uncovered.';
  const top = uncovered
    .slice(0, topN)
    .map((u) => `${u.name} (${compact.format(u.population)})`)
    .join(', ');
  const rest = uncovered.slice(topN);
  if (rest.length === 0) return `Not covered: ${top}.`;
  const restPop = rest.reduce((n, u) => n + u.population, 0);
  return `Not covered: ${top} + ${rest.length} more (${compact.format(restPop)} people).`;
}
